import { render, staticRenderFns } from "./OverlaySearch.vue?vue&type=template&id=010af686&"
import script from "./OverlaySearch.vue?vue&type=script&lang=js&"
export * from "./OverlaySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports